import { TeamAugmentationIcon, ManagedServicesIcon, ProjectsIcon, ProfessionalStaffingIcon } from '../icons';
import React from 'react';

const Card = ({ icon, title, points }) => (
  <div className="rounded-2xl border border-elowen-orange bg-white shadow-sm p-5 sm:p-6">
    <div className="mb-4">
      {icon}
    </div>
    <h3 className="text-[18px] sm:text-[20px] font-medium text-[#1A1A1A] mb-3">
      {title}
    </h3>
    <ul className="text-[14px] sm:text-[15px] leading-[1.6] text-[#1A1A1A] space-y-2">
      {points.map((p, i) => (
        <li key={i}>• {p}</li>
      ))}
    </ul>
  </div>
);

const EngagementModelsSection = () => {
  return (
    <section className="w-full py-12 md:py-16 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* Left copy */}
          <div className="lg:col-span-1 lg:pr-8 lg:mt-20 xl:mt-24 2xl:mt-28">
            <h2 className="text-[#1A1A1A] font-medium leading-tight mb-6 text-[30px] sm:text-[34px] md:text-[40px]">
              <span className="block">How We Work</span>
              <span className="block">With You</span>
            </h2>
            <p className="text-[#1A1A1A] text-[15px] sm:text-[16px] md:text-[18px] leading-[1.8] max-w-[460px]">
              Flexible engagement models designed to scale with your business, align with your goals, and adapt seamlessly as your technology and operational needs evolve.
            </p>
          </div>

          {/* Right cards */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card
              title="Managed Services"
              points={[
                'End‑to‑end management of IT infrastructure, platforms, and helpdesk',
                'Proactive monitoring to ensure performance, security, and uptime',
                'Reduced operational overhead with predictable service delivery',
              ]}
              icon={(
                <span className="text-elowen-orange">
                  <ManagedServicesIcon width={27} height={23} />
                </span>
              )}
            />

            <Card
              title="Projects"
              points={[
                'Fully outsourced or ODC‑based delivery models',
                'BOT support with IP protection and governance',
                'Structured execution from discovery to deployment',
              ]}
              icon={(
                <span className="text-elowen-orange">
                  <ProjectsIcon width={25} height={25} />
                </span>
              )}
            />

            <Card
              title="Team Augmentation"
              points={[
                'Skilled resources led or co‑located with your internal teams',
                'Flexible engagement aligned to delivery goals',
                'Low management overhead with SME‑driven execution',
              ]}
              icon={(
                <span className="text-elowen-orange">
                  <TeamAugmentationIcon width={40} height={21} />
                </span>
              )}
            />

            <Card
              title="Professional Staffing"
              points={[
                'On‑demand access to certified IT professionals',
                'Extended, outsourced, or co‑hosted teams',
                'Flexible contracts across onsite, remote, or hybrid models',
              ]}
              icon={(
                <span className="text-elowen-orange">
                  <ProfessionalStaffingIcon width={28} height={36} />
                </span>
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngagementModelsSection;
